import React from 'react'
import PropTypes from 'prop-types'

import Text from '../../../../Components/Formik/Text'

const OffNumberComponent = ({ translate }) => (
  <>
    <Text
      name="value"
      textHelper={translate('labels.offNumberHelper')}
      label={translate('labels.value')}
      type="number"
      min="1"
      max="65536"
      data-testid="number-input"
    />
  </>
)

OffNumberComponent.propTypes = {
  translate: PropTypes.func.isRequired
}

export default OffNumberComponent
